import {Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {InputCurrency} from '../../../components/InputCurrency'
import { InputGroup } from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useMutation, useQuery} from '@apollo/client'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {
  IResAllCommisionDeductionTypes,
  IResCreateCommissionUserDeduction,
  IResUpdateCommissionUserDeduction,
  IUserDeductionNode,
} from '../../../types/users'

import {ADD_USER_DEDUCTION, EDIT_USER_DEDUCTION} from '../../../gql/mutations/userMutations'
import { GET_ALL_USER_DEDUCTIONS_TYPE } from '../../../gql/queries/userDeductionTypesQuery'

interface IModalAddDeductionProps {
  keyboard: boolean
  backdrop: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  userId: string
  isEdit?: boolean
  userDeduction?: IUserDeductionNode | undefined
}

export const ModalAddDeduction: React.FC<IModalAddDeductionProps> = ({
  keyboard,
  backdrop,
  isOpen,
  onClose,
  userId,
  isEdit = false,
  userDeduction,
  refetch,
}) => {
  // console.log('userDeduction', userDeduction)
  const {
    data: dataDeductionsType,
    error: errorsDeductionsType,
  } = useQuery<IResAllCommisionDeductionTypes>(GET_ALL_USER_DEDUCTIONS_TYPE, {
    fetchPolicy: 'no-cache',
  })

  const [gqlCreate, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateCommissionUserDeduction>(ADD_USER_DEDUCTION)

  const [gqlUpdate, {data: dataUpdate}] =
    useMutation<IResUpdateCommissionUserDeduction>(EDIT_USER_DEDUCTION)

  const [deductionTypeSelected, setDeductionTypeSelected] = useState<null | 'PERCENTAGE' | 'FIXED'>(null)

  useEffect(() => {
    if (isEdit && userDeduction && dataDeductionsType?.allCommissionDeductionType) {
      const found = dataDeductionsType.allCommissionDeductionType.edges.find(
        (e) => e.node.id === userDeduction.deductionType?.id
      )
      if (found) {
        setDeductionTypeSelected(found.node.deductionType as 'PERCENTAGE' | 'FIXED')
      }
    }
  }, [isEdit, userDeduction, dataDeductionsType])


  const validationSchema = Yup.object({
    deductionType: Yup.string(), // opcional
    value: Yup.number().required('Value new is required'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId: userId, // ID del User
      deductionType: userDeduction?.deductionType?.id || '', // Porcentaje como string para poder usar input tipo texto
      value: userDeduction?.value || '',
    },
    validationSchema,
    onSubmit: (v) => {
      console.log('v', v)
      if (userDeduction && userDeduction.id) {
        gqlUpdate({
          variables: {
            id: parseId(userDeduction.id),
            input: {
              user: userId,
              deductionUserType: '' + parseId('' + v.deductionType) || null,
              value: '' + parseFloat(v.value),
            },
          },
        })
      } else {
        gqlCreate({
          variables: {
            input: {
              user: userId,
              deductionUserType: '' + parseId('' + v.deductionType) || null,
              value: '' + parseFloat(v.value),
            },
          },
        })
      }
    },
  })

  // useEffect(() => {
  //   if (errorPolicies) toast.error(`Error ${errorPolicies.message}`)
  // }, [errorPolicies])

  useEffect(() => {
    if (errorsDeductionsType) toast.error(`Error ${errorsDeductionsType.message}`)
  }, [errorsDeductionsType])

  useEffect(() => {
    if (errorCreate) toast.error(`Error ${errorCreate.message}`)
  }, [errorCreate])

  useEffect(() => {
    if (!dataCreate) return

    if (
      dataCreate.CommissionUserDeductionCreate.success &&
      dataCreate.CommissionUserDeductionCreate.commissionDeductionUser?.id
    ) {
      toast.success('Commission rate updated successfully')
      onClose()
      refetch()
    } else if (
      dataCreate.CommissionUserDeductionCreate.errors &&
      dataCreate.CommissionUserDeductionCreate.errors.length > 0
    ) {
      toast.error(dataCreate.CommissionUserDeductionCreate.errors[0]?.message || 'Created failed')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (!dataUpdate) return

    if (
      dataUpdate.CommissionUserDeductionUpdate.success
    ) {
      toast.success('Commission rate updated successfully')
      onClose()
      refetch()
    } else if (
      dataUpdate.CommissionUserDeductionUpdate.errors &&
      dataUpdate.CommissionUserDeductionUpdate.errors.length > 0
    ) {
      toast.error(dataUpdate.CommissionUserDeductionUpdate.errors[0]?.message || 'Update failed')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate])

  return (
    <Modal
      className='modal-add-commission'
      backdrop='static'
      keyboard={false}
      show={isOpen}
      onHide={onClose}
    >
      {/* <Modal show={isOpen} onHide={onClose}> */}
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Edit' : 'Add'} deduction</Modal.Title>
      </Modal.Header>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <Row>
            <Col sm={12} md={12}>
              <Form.Group>
                <Form.Label htmlFor='deductionType'>Type</Form.Label>
                {dataDeductionsType?.allCommissionDeductionType && (
                  <Form.Select
                    id='deductionType'
                    name='deductionType'
                    value={formik.values.deductionType}
                    onChange={(e) => {
                      const selectedId = e.target.value || ''
                      formik.setFieldValue('deductionType', selectedId)

                      const selectedType = dataDeductionsType?.allCommissionDeductionType.edges.find(
                        ({ node }) => node.id === selectedId
                      )

                      if (selectedType) {
                        const node = selectedType.node
                        setDeductionTypeSelected(node.deductionType as 'PERCENTAGE' | 'FIXED')
                        if (node.value !== null) {
                          formik.setFieldValue('value', node.value)
                        }
                      }
                    }}
                  >
                    <option value=''>Select Deduction Type</option>
                    {dataDeductionsType?.allCommissionDeductionType.edges.map(({node}) => (
                      <option key={node.id} value={node.id}>
                        {node.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className='mb-3'>
            <Form.Label>Value</Form.Label>
            {deductionTypeSelected === 'PERCENTAGE' ? (
              <InputGroup>
                <Form.Control
                  type='number'
                  name='value'
                  value={formik.values.value}
                  onChange={(e) => formik.setFieldValue('value', e.target.value)}
                  placeholder='Enter percentage'
                />
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup>
            ) : (
              <InputCurrency
                name='value'
                value={formik.values.value}
                prefix='$'
                onValueChange={(val) => formik.setFieldValue('value', val || '0')}
              />
            )}
            {formik.touched.value && typeof formik.errors.value === 'string' && (
              <small className='text-danger'>{formik.errors.value}</small>
            )}
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' size='sm' onClick={onClose} type='button'>
            Close
          </Button>
          <Button variant='primary' size='sm' type='submit' >
            {loadingCreate && <Spinner animation='border' size='sm' className='me-2' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
